
export enum DepRecoMode  {
  common ='common',
  optimal = 'optimal'
}

